import React from "react";
import "./BuildTeam.scss";
import { BuildTeamConstants } from "./BuildTeamConstants";

const BuildTeam: React.FC = () => {
    const { logo, heading, description, appStores } = BuildTeamConstants;

    return (
        <section className="build-team-section">
            <div className="build-team-container">
                <div className="build-team-logo">
                    <img src={logo} alt="Cric Center Logo" />
                </div>

                <div className="build-team-content">
                    <h2 className="build-team-heading">{heading}</h2>
                    <p className="build-team-description">{description}</p>

                    <div className="app-stores">
                        {appStores.map((store, index) => (
                            <a
                                key={index}
                                href={store.link}
                                className={`app-store-btn ${store.type}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={store.name}
                            >
                                <img
                                    src={store.image}
                                    alt={store.name}
                                    className="app-store-badge-img"
                                />
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BuildTeam;
